import { MessageCircle, FileEdit, ShieldCheck, GraduationCap, PlaneTakeoff, Heart } from "lucide-react";

const STEPS = [
  { icon: MessageCircle, title: "Konsultasi" },
  { icon: FileEdit, title: "Pendaftaran" },
  { icon: ShieldCheck, title: "Verifikasi Data" },
  { icon: GraduationCap, title: "Pembinaan & Manasik" },
  { icon: PlaneTakeoff, title: "Persiapan Keberangkatan" },
  { icon: Heart, title: "Pendampingan Jamaah" },
];

export default function JourneyProcess() {
  return (
    <section className="bg-[#F5F9F7] py-20" data-testid="journey-process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Alur Perjalanan</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Bagaimana Prosesnya?</h2>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-6">
          {STEPS.map((step, idx) => (
            <div key={step.title} data-testid={`journey-step-${idx}`} className="relative flex flex-col items-center text-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-[#0F6B4F] shadow-[0_2px_16px_rgba(15,107,79,0.1)]">
                <step.icon className="h-7 w-7" />
              </div>
              <span className="absolute -top-2 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-[#0F6B4F] text-xs font-bold text-white">
                {idx + 1}
              </span>
              <p className="mt-4 text-sm font-medium text-[#1F2937]">{step.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
